import React from 'react'
import Meta from '../modules/meta'
import './galerie.scss'

import cabinetBureau from '../images/cabinet/bureau-cabinet-psychologue-montpellier.jpg'
import cabinetBureau2 from '../images/cabinet/bureau-cabinet-psychologue-montpellier-1.jpg'

const metadata = {
  title:
    'Cabinet Psychologue à Montpellier | Psychologue clinicienne à Montpellier quartier les arceaux  | Morgane Laroche',
  description:
    'Je reçois les adultes en entretien individuels sur rendez-vous sur rendez-vous, du Lundi au Jeudi. Les consultations ont lieu dans mon cabinet situé au 300 Rue Auguste Broussonnet à Montepllier, à deux pas de l’arrêt de tram Place Albert 1er – Saint Charles.',
}
const GaleriePage = () => (
  <div>
    <Meta title={metadata.title} description={metadata.description} />
    <div className="container">
      <div className="container__galery">
        <div className="galery__office">
          <img
            src={cabinetBureau}
            alt="mon cabinet psy à montpellier, montpellier psychologue, psychologue montpellier, avis psychologue, psychologue clinicienne quartier les arceaux, psychologue montpellier, psy montpellier"
          />
          <img
            src={cabinetBureau2}
            alt="bureau psy à montpellier, bureau psychologue à montpellier, montpellier psychologue, psychologue montpellier, avis psychologue, psychologue clinicienne à Montpellier, cabinet de psychologie à Montpellier, psychologue montpellier, psy montpellier"
          />
        </div>
      </div>
    </div>
  </div>
)

export default GaleriePage



// WEBPACK FOOTER //
// ./src/pages/galerie.js